module.exports = __webpack_public_path__ + "static/media/rm_06-02.8cb6364d.png";